module.exports = __webpack_public_path__ + "media/images/weather/268_night-c63111a35d82965696a38fad7f559f18.png";